// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"masonry_wrapper__Sc1Vj","coverPhoto":"masonry_coverPhoto__y_xQd","column":"masonry_column__lzeKE"};